import React, {useState,useEffect,useRef} from 'react';
import { useQueryParam, StringParam } from 'use-query-params';
import Select from 'react-select'


const RatingFilter = (prop) => {


    const ref = useRef()

    const [isMenuOpen, setIsMenuOpen] = useState(false)
    const [selectedRating, setSelectedRating] = useState("")
    const [selectedRatingLabel, setSelectedRatingLabel] = useState("")
    const [closeFilter, setCloseFilter] = useState(false);
    const [rated, setRated] = useQueryParam('rate', StringParam);


    const selectOptions=[
        { value: 'rated', label: 'Any Rating' },
        { value: 'not_rated', label: 'Not Rated' },
        { value: 'rated_bad', label: 'Rated Bad' },
        { value: 'rated_good', label: 'Rated Good' },
        { value: 'rated_bad_commented', label: 'Rated bad & Commented' },
        { value: 'rated_good_commented', label: 'Rated good & Commented' },

    ];
    const closeFilterFunc=()=>{
        setRated(undefined);
        prop.closeFilter(prop.filterDetail['name']);
        prop.filtering();
    }
    const completeSelect=()=>{


        setRated(selectedRating);

        prop.filtering();
    }

    const onMouseOver=()=>{
        setCloseFilter(true);
    }
    const onMouseOut=()=>{
        setCloseFilter(false);
    }


    const closeWrap=()=>{

        if(typeof rated==="undefined"){
            setRated(undefined);
            prop.closeFilter(prop.filterDetail['name']);
        }
        setIsMenuOpen(false);
    }
    const doneSelect=()=>{
        completeSelect();
        setIsMenuOpen(false);
    }
    const selectRate=(selectedOption)=>{
        setSelectedRating(selectedOption.value);
        setSelectedRatingLabel(selectedOption.label);




    }
    const  changeMenuOpen=(state)=>{
        prop.changeShowIs(state,prop.filterDetail['name']);
    }
    useEffect(() => {

        if(typeof rated!=="undefined"){



            var $filter=selectOptions.filter((e)=>e.value==rated);
            if($filter.length>0){
                setSelectedRatingLabel($filter[0]['label']);
            }
            setSelectedRating(rated);
        }
        if(!prop.showis){

            setIsMenuOpen(true);
            changeMenuOpen(true);
        }
    }, [prop.showis])

    useEffect(() => {

        const checkIfClickedOutside = e => {
            if (isMenuOpen && ref.current && !ref.current.contains(e.target)) {
                setIsMenuOpen(false);
                if(typeof rated==="undefined"){
                    setRated(undefined);
                    prop.closeFilter(prop.filterDetail['name']);
                }

            }
        }
        document.addEventListener("mousedown", checkIfClickedOutside)
        return () => {
            document.removeEventListener("mousedown", checkIfClickedOutside)
        }
    }, [isMenuOpen])

    return (

        <div
            className="filter-item"
            ref={ref}>
            <button
                onMouseEnter={onMouseOver}
                onMouseLeave={onMouseOut}
                onClick={() => setIsMenuOpen(oldState => !oldState)}
                className=" selected-filter-button">
                {closeFilter === false &&
                <i className={prop.filterDetail['icon']} ></i>
                }

                {closeFilter===true &&
                <i
                    onClick={closeFilterFunc}
                    className="bx bx-x" ></i>
                }

                {selectedRatingLabel != "" &&
                <span>{selectedRatingLabel}</span>
                }
                {selectedRatingLabel == "" &&
                <span>{prop.filterDetail['name']}</span>
                }

            </button>

            {isMenuOpen === true &&
            <div className="filter-item-wrap">
                <div className="filter-item-content">
                    <div className="filter-item-content-header">
                        <span><i className={prop.filterDetail['icon']}></i></span>
                        <span>{prop.filterDetail['name']}</span>

                    </div>
                    <div className="form">
                        <Select
                            defaultValue={
                                selectOptions.filter(option =>
                                    option.value == selectedRating)
                            }
                            options={selectOptions}
                            closeMenuOnSelect={true}
                            placeholder="choose rating"
                            onChange={selectRate}
                            noOptionsMessage={() => "rating not found"}

                        />
                    </div>
                    <div className="form">
                        {selectedRating=="" &&
                        <button
                            onClick={closeWrap}
                            className="btn btn-primary btn-lg btn-block">Close</button>
                        }
                        {selectedRating!="" &&
                        <button
                            onClick={doneSelect}
                            className="btn btn-primary btn-lg btn-block"
                        >Done</button>
                        }
                    </div>
                </div>
            </div>
            }
        </div>

    );

};

export default RatingFilter;
